import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { fetchEnterpriseIntakeByFormId } from "../../services/enterpriseIntakeAdmin";
import EnterpriseIntake from "./EnterpriseIntake";

const EnterpriseIntakeOwnerReview = () => {
  const { formId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      const record = await fetchEnterpriseIntakeByFormId(formId);
      if (cancelled) return;
      if (
        !record ||
        (!record.corporateEmail?.trim() &&
          !record.companyName?.trim() &&
          !record.fullName?.trim())
      ) {
        navigate("/leads", { replace: true });
        return;
      }
      setData(record);
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [formId, navigate]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "40vh",
          width: "100%",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!data) return null;

  return (
    <EnterpriseIntake readOnly prefilledData={data} ownerBackTo="/leads" />
  );
};

export default EnterpriseIntakeOwnerReview;
